
const aboutbondsissuer = {
    "About Issuer and the Issue": [
        {
          question: "Who is the issuer of the bond?",
          answer: "Issuer of the bond is Spandan Spoorthy Financial Limited. It is a stock exchange listed NBFC. The company engages in activities of Microfinance and Secured Lending and manages AUM of INR 8,000cr+."
        },
        {
          question: "What is the security of my investments?",
          answer: "The issue is secured by the hypothecated assets which at any point of time will be 1.1x i.e 110%  of the outstanding amount of investment. "
        },
        {
          question: "What are the financials of the Issuer?",
          answer: "Spandana Spoorthy is a profitable company with following details as on 20th June 2023, Profit after Tax of INR 111cr, Debt to Equity ratio of 1.98 and Net non-performing assets of 0.49% ."
        },
        {
          question: "In what scenarios can investors call for early redemption from Issuer?",
          answer: "Issuer needs to ensure they maintain GNPA of less than 8%, NNPA of less than 5%, after tax net income should be in positive, capital adequacy ratio should not go below regulatory guidelines and corporate promoter (Kedaara Capital) should not have less than 26% shareholding in company. Failing to these conditions, investors will have right to call for early redemption."
        }
      ],
  }
  
  export default aboutbondsissuer;